export interface billingAddress {
  name: string;
  businessName: string;
  streetAddress: string;
  unitSuite: string;
  city: string;
  province: string;
  postalCode: string;
}
export interface shippingAddress {
  name: string;
  businessName: string;
  streetAddress: string;
  unitSuite: string;
  city: string;
  province: string;
  postalCode: string;
  sameAsBillingAddress?: boolean;
}

export interface IKitter {
  id: string;
  name: string;
}

// A single order lot (Kit or Box). `id` is round-tripped so existing rows
// update instead of duplicating; `dateModified`/`modifiedBy` are read-only audit.
export interface ILot {
  id?: number;
  productType?: string;
  quantity: number;
  lotNumber: string;
  expiry: string;
  dateModified?: string;
  modifiedBy?: { id: string; name: string } | null;
}

// Mirrors the backend OrderSource enum. The API serializes it as its numeric
// value (no JsonStringEnumConverter configured), so `source` arrives as a number.
// eslint-disable-next-line no-shadow
export enum OrderSource {
  Website = 0,
  Admin = 1,
  ThunderBird = 2,
}

export const OrderSourceLabel: Record<number, string> = {
  [OrderSource.Website]: 'Website',
  [OrderSource.Admin]: 'Admin',
  [OrderSource.ThunderBird]: 'ThunderBird',
};

export interface IOrderItem {
  id: number;
  pid: string;
  customerName?: string;
  orderDate?: string;
  status: string;
  source: OrderSource;
  phoneNumber: string;
  name: string;
  emailAddress: string;
  flashTitleUrl: string | null;
  billingAddress: billingAddress;
  shippingAddress: shippingAddress;
  nextStatus: string;
  kitter: string;
  kitterId: string;

  // products
  numberOfKits: number;
  numberOfBoxes: number;
  numberOfWallUnitBundles: number;
  numberOfWallUnitWayFinderBundles: number;
  numberOfWayFinders: number;

  // Lots (returned by the single-order read)
  kitLots?: ILot[];
  boxLots?: ILot[];
}

interface Selections {
  Status: string[];
  Kitter: string[];
  Source: string[];
}

export interface Aggregate {
  value: number;
  type: string;
}

export interface Aggregates {
  NewOrders: Aggregate;
  Kitting: Aggregate;
  OrdersInShipping: Aggregate;
  OrdersDelivered: Aggregate;
}

export interface OrdersData {
  items: IOrderItem[];
  selections: Selections;
  aggregates: Aggregates;
  currentPage: number;
  maxPage: number;
  total: number;
  permissions: Object;
}
